import SliderInterface from '../../../components/Slider/interfaces/SliderInterface';

/**
 * Load Page Parts dynamically
 */
export default class PagePartsChunk {
  private trackingObserver: IntersectionObserver;

  private readonly body: HTMLElement;

  constructor() {
    this.body = document.querySelector('body');

    if (!this.body.classList.contains('js-pageParts--processed')) {
      const sliderTendanceElement: HTMLElement =
        document.querySelector('.c-sliderTendance');
      const shopDecoElement: HTMLElement = document.querySelector(
        '.c-landing__modalTemplate'
      );
      const copyValueElement: HTMLElement =
        document.querySelector('.js-copyValue');
      const accordionElement: HTMLElement = document.querySelector(
        '.c-accordionPagePart'
      );
      const playersElements: NodeListOf<HTMLElement> =
        document.querySelectorAll('.js-player-eminza');

      this.body.classList.add('js-pageParts--processed');

      // Load Slider Tendance
      if (sliderTendanceElement) {
        PagePartsChunk.importSliderTendanceChunks();
      }

      // Load Video Player
      if (playersElements.length > 0) {
        PagePartsChunk.importPlayerVideo(playersElements);
      }

      // Load Shop Deco
      if (shopDecoElement) {
        PagePartsChunk.importShopDeco();
      }

      // Load Copy Value
      if (copyValueElement) {
        PagePartsChunk.importCopyDataValue();
      }

      // Load Accordion
      if (accordionElement) {
        PagePartsChunk.importAccordionPagePart();
      }
    }
  }

  /**
   * Import SliderTendance
   */
  private static importSliderTendanceChunks() {
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-SliderTendance' */ '../../../components/Slider/SliderTendance/SliderTendance'
    ).then(({ default: SliderTendance }) => {
      const sliderTendanceConfig: SliderInterface = {};
      new SliderTendance(sliderTendanceConfig);
    });
  }

  /**
   * Import SliderTendance
   */
  static importPlayerVideo(players: NodeListOf<HTMLElement>) {
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-VideoPlayer' */ '../../../components/VideoPlayer/VideoPlayer'
    ).then(({ default: VideoPlayer }) => {
      players.forEach((player) => {
        if (player instanceof HTMLElement) {
          new VideoPlayer(player);
        }
      });
    });
  }

  /*
   * Open modal Shop Deco
   * */
  static importShopDeco() {
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-ShopDeco' */ '../../../components/ShopDeco/ShopDeco'
    ).then(({ default: ShopDeco }) => {
      new ShopDeco();
    });
  }

  /*
   * Copy value
   * */
  static importCopyDataValue() {
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-CopyDataValue' */ 'modules/InitChunks/PagePartsChunk/pageParts/copyDataValue'
    ).then(({ default: copyDataValue }) => {
      copyDataValue();
    });
  }

  /*
   * Accordion page part
   * */
  static importAccordionPagePart() {
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-AccordionPagePart' */ 'modules/InitChunks/PagePartsChunk/pageParts/accordionPagePart'
    ).then(({ default: accordionPagePart }) => {
      accordionPagePart();
    });
  }
}
